import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';

import { QUERY_POST } from '../utils/queries';

import Button from 'react-bootstrap/Button';

import SignupModal from '../components/SignupModal';

import { useDocumentTitle } from '../components/useDocumentTitle';

import spinner from '../assets/spinner.gif';

import './BlogPost.css';

function storeName(url) {
  const re = /\/\/(www\.)?([^/]+)/;
  const matches = url.match(re)
  return matches[2] === 'amzn.to' ? 'Amazon' : matches[2];
}

function BlogPost() {
  const dispatch = useDispatch();

  const { id } = useParams();

  const [post, setPost] = useState(null);

  const { loading, error, data } = useQuery(QUERY_POST, {variables: {id}});

  useDocumentTitle(`${post ? post.title : ''} | Blog`);

  useEffect(() => {
    if (data) {
      setPost(data.post);
    }
  }, [data, loading, dispatch, id]);

  if (error) {
    return `Query error: ${error.message}`;
  }

  return (
    <>
      <nav className="breadcrumb"><Link to="/blog">Blog</Link></nav>

      {post ? (
        <div className="blog-post">
          <h2>{post.title}</h2>

          {post.image &&
            (
              post.productLink ?
                <a href={post.productLink}>
                  <img src={`/image/${post.image}`} className="hero" alt="Shop this product on {storeName(post.productLink)}" />
                </a> : <img src={`/image/${post.image}`} className="hero" alt=" " />
            )}

          <p>{post.post ? post.post.trim() : ''}</p>

          {post.productLink ?
              <Button className="shop-link" href={post.productLink}>
                Shop this product on {storeName(post.productLink)}
              </Button> : null}
        </div>
      ) : null}

      <SignupModal />

      {loading ? <img src={spinner} alt="loading" /> : null}
    </>
  );
}

export default BlogPost;

